import { useEffect as r } from "react";
function t(n) {
  const e = document.querySelector(`link[rel~='icon'][href="${n}"]`);
  e !== null && e.remove();
}
function i(n) {
  r(() => {
    var o;
    if (!n)
      return () => {
      };
    let e = document.querySelector("link[rel~='icon']");
    return e || (e = document.createElement("link"), e.rel = "icon", (o = document.querySelector("head")) == null || o.appendChild(e)), e.href = n, () => {
      t(n);
    };
  }, [n]);
}
export {
  i as useFavicon
};
//# sourceMappingURL=useFavicon.js.map
